import { motion } from 'framer-motion';

const About = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8'
    >
      <h1 className='text-3xl font-bold text-red-400 mb-6'>About MediVerify</h1>

      <div className='bg-white rounded-lg shadow-md p-6'>
        <section className='mb-8'>
          <h2 className='text-2xl font-semibold text-gray-800 mb-4'>Our Mission</h2>
          <p className='text-gray-600 leading-relaxed'>
            At MediVerify, we are committed to ensuring the safety and authenticity of medical
            products. Our advanced verification system helps consumers and healthcare professionals
            verify the legitimacy of their medications and medical supplies, protecting public
            health and fighting against counterfeit products.
          </p>
        </section>

        <section className='mb-8'>
          <h2 className='text-2xl font-semibold text-gray-800 mb-4'>What We Do</h2>
          <p className='text-gray-600 leading-relaxed'>
            We provide a simple yet powerful verification system that allows users to check the
            authenticity of medical products using unique scratch codes. Our platform maintains a
            comprehensive database of legitimate products and works closely with manufacturers to
            ensure accurate verification results.
          </p>
        </section>

        <section>
          <h2 className='text-2xl font-semibold text-gray-800 mb-4'>Our Values</h2>
          <ul className='list-disc list-inside text-gray-600 leading-relaxed'>
            <li>Integrity in all our operations</li>
            <li>Commitment to public health and safety</li>
            <li>Innovation in verification technology</li>
            <li>Collaboration with healthcare stakeholders</li>
            <li>Transparency in our processes</li>
          </ul>
        </section>
      </div>
    </motion.div>
  );
};

export default About;
